export default {
    password: {
        title: "Lozinka",
        currentPassword: "Trenutna lozinka",
        confirmPassword: "Potvrda nove lozinke",
        password: "Nova lozinka",
        button: "Update",
        successMessage: "Lozinka je uspješno promijenjena.",
    },
    email: {
        title: "Email",
        emailLabel: "Email",
        button: "Update",
        successMessage: "Email je uspješno promijenjen.",
    },
    paymentMethod: {
        title: 'Način plaćanja',
        cardholder: 'Ime vlasnika kartice',
        button: {
            edit: "Izmijeni",
            removeCard: "Ukloni karticu",
            addCard: "dodaj karticu",
        },
        validThru: 'Datum validnosti kartice',
        billingAddress: 'Adresa naplate',
        modal: {
            addCard: 'Dodaj karticu',
            editCard: 'Izmijeni karticu',
            cardInformation: 'Informacije kartice',
            billingAddress: 'Adresa naplate',
            input: {
                firstName: {
                    label: 'Ime',
                    placeholder: 'Unesi ime'
                },
                lastName: {
                    label: 'Prezime',
                    placeholder: 'Unesi prezime'
                },
                cardNumber: {
                    label: 'Broj kartice',
                    placeholder: '0000 0000 0000 0000',
                },
                validThru: {
                    label: 'Datum validnosti',
                    placeholder: 'MM/YY',
                },
                cvv: {
                    label: 'CVV',
                    placeholder: '000',
                },
                country: 'Država',
                city: {
                    label: 'Grad',
                    placeholder: 'Odaberite grad',
                },
                address: {
                    label: 'Adresa',
                    placeholder: 'Unesite adresu'
                },
                zipCode: {
                    label: 'Poštanski broj',
                    placeholder: '00000'
                },
                phoneNumber: {
                    label: 'Broj telefona',
                    placeholder: '067/067-067'
                }
            },
            button: {
                cancel: 'Otkaži',
                save: 'Sačuvaj',
                add: 'Dodaj'
            }
        }
    },
    deleteAccount: {
        title: "Obriši nalog",
        warningMessage: "Jednom kada izbrišete nalog, nema povratka. Molimo Vas budite sigurni.",
        emailLabel: "Email",
        button: "Obriši nalog",
        modal: {
            title: "Da li ste sigurni da želite da uradite ovo?",
            deleteDataWarning: "Odmah ćemo izbrisati sve vaše podatke, uključujući adrese, porudžbine, komentare, ocjene, proizvode iz korpe i sa liste želja.",
            storeAccessWarning: "Takođe nećete moći da pristupite nijednoj prodavnici koja je povezana sa Vašim nalogom.",
            emailLabel: "Vaš email",
            confirmPassword: "Potvrdite lozinku",
        }
    },
    user: {
        title: "Informacije o korisniku",
        avatar: "Avatar",
        firstName: "Ime",
        lastName: "Prezime",
        fullName: "Ime i prezime",
        button: "Update",
        successMessage: "Informacije o korisniku su uspješno promijenjene.",
        settings: {
            title: 'Podešavanja',
            session: {
                title: "Sesije",
                loginHistory: "Pregled istorije Vaših prijava",
                activeNow: "Trenutno aktivan",
                logOut: "Odjavi se",
            },
            account: {
                title: "Podešavanja naloga",
                buttons: {
                    edit: "Izmijeni",
                    cancel: "Otkaži",
                    save: "Sačuvaj"
                },
                firstName: "Ime",
                lastName: "Prezime",
                email: "Email",
                password: "Lozinka",
                city: "Grad",
                street: "Ulica",
                number: "Broj ulice"
            },
            twoFactorAuth: {
                title: 'Two-factor autentifikacija',
                helpProtectAccount: {
                    title: 'Pomoć pri zaštiti Vašeg profila',
                    message: "Ako primijetimo pokušaj prijave sa uređaja ili pretraživača koji ne prepoznajemo, pitaćemo Vas za lozinku i verifikacioni kod."
                },
                twoFactorIsOn: {
                    title: 'Two-face autentifikacija je uključena',
                    message: "Pitaćemo Vas za verifikacioni kod putem Vašeg bezbjednosnog metoda ako primetimo prijavu sa nepoznatog uređaja ili pretraživača."
                },
                method: {
                    label: {
                        security: {
                            selectMethod: 'Izaberite metod zaštite',
                            yourMethod: 'Vaš metod zaštite'
                        },
                        backup: 'Dodaj metod rezervne kopije'
                    },
                    authApp: {
                        title: 'Aplikacija za potvrdu identiteta',
                        reccomended: 'Preporučeno',
                        message: 'Koristite Google Authenticator da biste generisali verifikacione kodove za veću zaštitu.',
                        button: 'Koristi aplikaciju za potvrdu identiteta',
                        selectedMethod: {
                            message: "Kod za prijavu ćete dobiti preko aplikacije za potvrdu identiteta",
                            button: 'Isključi'
                        }
                    },
                    textMsg: {
                        title: 'Tekstualna poruka (SMS)',
                        message: "Koristite tekstualne poruke (SMS) za primanje verifikacionih kodova. Radi Vaše zaštite, telefonski brojevi koji se koriste za two-factor autentifikaciju ne mogu se koristiti za resetovanje lozinke kada je two-factor autentifikacija uključena.",
                        button: 'Koristi tekstualnu poruku (SMS)'
                    },
                    recoveryCodes: {
                        title: 'Kodovi oporavka',
                        message: "Koristite kodove za oporavak da biste se prijavili ako izgubite telefon ili ne možete da primite verifikacioni kod putem tekstualne poruke ili aplikacije za potvrdu identiteta",
                        button: 'Podesi'
                    }
                },
                modal: {
                    title: 'Two-factor autentifikacija',
                    thirdParty: {
                        title: 'Podesite preko nezavisnog autentifikatora',
                        message: 'Za skeniranje ovog QR koda koristite Google Authenticator.',
                        enterCode: 'Ili unesite ovaj kod u aplikaciju za potvrdu identiteta',
                        button: {
                            close: 'Zatvori',
                            secureAccount: 'Zaštiti nalog'
                        }
                    },
                    selectNumber: {
                        title: 'Izaberite svoj broj telefona',
                        message: 'Izaberite broj mobilnog telefona koji je već na Vašem nalogu ili dodajte novi broj za two-factor autentifikaciju. Ovo je broj na koji ćete dobiti verifikacioni kod.',
                        addPhoneNumber: 'Dodaj broj telefona',
                        button: {
                            close: 'Zatvori',
                            continue: 'Nastavi'
                        }
                    },
                    addNumber: {
                        title: 'Dodaj broj telefona',
                        message: 'Ovaj broj će biti omogućen za two-factor autentifikaciju i prijavu.',
                        input: {
                            countryCode: 'Državni pozivni broj',
                            phoneNumber: {
                                label: 'Broj telefona',
                                placeholder: 'Unesi broj telefona'
                            }
                        },
                        button: {
                            close: 'Zatvori',
                            continue: 'Nastavi'
                        }
                    },
                    enterCode: {
                        title: 'Unesi kod',
                        message: 'Unesite šestocifreni kod koji ste dobili da biste završili postavljanje two-factor autentifikacije.',
                        button: {
                            close: 'Zatvori',
                            continue: 'Nastavi',
                            resendCode: 'Ponovo pošalji kod'
                        }
                    },
                    authIsOn: {
                        title: 'Two-Factor autentifikacija je uključena',
                        message: "Na ovaj broj ćemo poslati verifikacioni kod ako primetimo pokušaj prijave sa uređaja ili pretraživača kojeg ne prepoznamo",
                        button: {
                            confirm: 'Potvrdi'
                        }
                    },
                    recoveryCodes: {
                        title: 'Kodovi za oporavak',
                        message: "Koristite kodove za oporavak da biste se prijavili ako izgubite telefon ili ne možete da primite verifikacioni kod putem tekstualne poruke ili aplikacije za potvrdu identiteta.",
                        button: {
                            close: 'Zatvori',
                            getCodes: 'Traži kodove'
                        },
                        listedCodes: {
                            of: 'od',
                            remaining: 'preostalih',
                            code: 'KOD',
                            button: {
                                getNewCodes: 'Traži nove kodove',
                                download: 'Preuzmi',
                                close: 'Zatvori'
                            }
                        }
                    }
                }
            },
        }
    },
    interests: {
        title: 'Kategorije prodavnica'
    },
    addresses: {
        deliveryAddressesCard: {
            title: 'Adrese dostave',
            button: {
                edit: 'Izmijeni',
                primaryAddress: 'Glavna adresa',
                setAsPrimaryAddress: 'Podesi kao glavnu adresu',
                addNewAddress: 'Dodaj novu adresu'
            }
        },
        modal: {
            addNewAddressTitle: 'Dodaj novu adresu',
            editAddressTitle: 'Izmijeni adresu',
            input: {
                firstName: {
                    label: 'Ime',
                    placeholder: 'Unesite ime'
                },
                lastName: {
                    label: 'Prezime',
                    placeholder: 'Unesite prezime'
                },
                country: {
                    label: 'Država'
                },
                city: {
                    label: 'Grad',
                    placeholder: 'Odaberite grad'
                },
                address: {
                    label: 'Ulica',
                    placeholder: 'Unesite ulicu'
                },
                addressNumber: {
                    label: 'Broj',
                    placeholder: 'xx'
                },
                phoneNumber: {
                    label: 'Broj telefona',
                    placeholder: '067/000-000'
                },
            },
            button: {
                cancel: "Otkaži",
                add: "Dodaj",
                save: "Sačuvaj",
                delete: "Obriši"
            }
        },
        toastr: {
            addressAdded: 'Adresa je uspješno dodata',
            addressEdited: 'Adresa je uspješno izmijenjena',
            addressDeleted: 'Adresa je uspješno obrisana',
        }
    }
};

